export interface ReportsDateRangeValue {
  dateFrom: string;
  dateTo: string;
}

export function toDateRangeParameters(
  value: ReportsDateRangeValue
): { dateFrom: string | null; dateTo: string | null } {
  return {
    dateFrom: value.dateFrom.trim() === '' ? null : value.dateFrom,
    dateTo: value.dateTo.trim() === '' ? null : value.dateTo,
  };
}
